/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Loading_LabelInputs */



/**
* | output |
* | --- |
* | "Loading guides... please wait..." |
*
* @param {Style_Guide_Manager_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_loading_label = /** @type {((inputs?: Style_Guide_Manager_Loading_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Loading_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des guides... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anleitungen werden geladen... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento delle guide... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка инструкций... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando guías... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载指南……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ガイドを読み込んでいます...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गाइड लोड हो रहे हैं... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando guias... aguarde...")
	return /** @type {LocalizedString} */ ("Loading guides... please wait...")
});